/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A knot equals 1 nautical mile per hour, and a nautical mile is defined as one minute of latitude — a unit tied directly to navigation charts and the Earth's geometry. That made manual position-and-speed calculations easier long before GPS, and the convention has stuck in maritime and aviation use.`)
};

const es_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nudo equivale a 1 milla náutica por hora, y una milla náutica se define como un minuto de latitud — una unidad directamente vinculada a gráficos de navegación y la geometría de la Tierra. Eso hizo que los cálculos de posición y velocidad manual fueran más fáciles mucho antes del GPS, y la convención se ha adherido en el uso marítimo y de aviación.`)
};

const de_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Knoten entspricht 1 Seemeile pro Stunde, und eine Seemeile ist als eine Bogenminute Breitengrad definiert — eine Einheit, die direkt mit Seekarten und der Geometrie der Erde verknüpft ist. Das erleichterte manuelle Positions- und Geschwindigkeitsberechnungen lange vor GPS, und die Konvention hat sich in der Schifffahrt und Luftfahrt gehalten.`)
};

const nl_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een knoop is gelijk aan 1 zeemijl per uur, en een zeemijl is gedefinieerd als één minuut breedteligging — een eenheid rechtstreeks gekoppeld aan navigatiekaarten en de geometrie van de Aarde. Dat maakte handmatige positie- en snelheidsberekeningen gemakkelijker ver vóór GPS, en de conventie is blijven steken in maritiem en luchtvaart gebruik.`)
};

const fr_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nœud égale 1 mille nautique par heure, et un mille nautique est défini comme une minute de latitude — une unité directement liée aux cartes de navigation et à la géométrie de la Terre. Cela rendait les calculs manuels de position et de vitesse plus faciles bien avant le GPS, et la convention s'est maintenue dans l'usage maritime et aéronautique.`)
};

const it_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nodo equivale a 1 miglio nautico all'ora, e un miglio nautico è definito come un minuto di latitudine — un'unità direttamente legata alle carte di navigazione e alla geometria della Terra. Ciò ha reso i calcoli manuali di posizione e velocità più facili molto prima del GPS, e la convenzione si è mantenuta nell'uso marittimo e dell'aviazione.`)
};

const pt_br2_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um nó é igual a 1 milha náutica por hora, e uma milha náutica é definida como um minuto de latitude — uma unidade diretamente vinculada a cartas de navegação e à geometria da Terra. Isso tornou cálculos manuais de posição e velocidade mais fáceis muito antes do GPS, e a convenção permaneceu no uso marítimo e aeronáutico.`)
};

const pt_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um nó é igual a 1 milha náutica por hora, e uma milha náutica é definida como um minuto de latitude — uma unidade ligada directamente aos gráficos de navegação e à geometria da Terra. Isto tornou os cálculos de posição e velocidade manual mais fáceis muito antes de GPS, e a convenção aderiu ao uso marítimo e aviação.`)
};

const ja_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノットは1海里毎時に等しく、海里は緯度の1分として定義され — ナビゲーション地図と地球の幾何学に直接関連付けられた単位。これは GPS 前に手動の位置スピード計算をより簡単にし、慣例は海洋と航空の使用に固执しています。`)
};

const zh_uc_speed_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq2_a", locale)
	if (locale === "en") return en_uc_speed_faq2_a(inputs)
	if (locale === "es") return es_uc_speed_faq2_a(inputs)
	if (locale === "de") return de_uc_speed_faq2_a(inputs)
	if (locale === "nl") return nl_uc_speed_faq2_a(inputs)
	if (locale === "fr") return fr_uc_speed_faq2_a(inputs)
	if (locale === "it") return it_uc_speed_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq2_a(inputs)
	if (locale === "pt") return pt_uc_speed_faq2_a(inputs)
	if (locale === "ja") return ja_uc_speed_faq2_a(inputs)
	return zh_uc_speed_faq2_a(inputs)
};